import { render, staticRenderFns } from "./CageCard.vue?vue&type=template&id=64979cc4&scoped=true&"
import script from "./CageCard.vue?vue&type=script&lang=js&"
export * from "./CageCard.vue?vue&type=script&lang=js&"
import style0 from "./CageCard.vue?vue&type=style&index=0&id=64979cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64979cc4",
  null
  
)

export default component.exports